import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  padding-top: 24px;

  position: relative;
`;

// Used by update availabilities modal
export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  width: auto;

  display: flex;
  justify-content: start;
  flex-direction: column;
  column-gap: 16px;
`;

export const CheckBoxContainer = styled.div`
  width: auto;

  display: flex;
  flex-direction: row;
  row-gap: 16px;
  align-items: center;
`;
